import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { PlessViewHelperSub } from "src/app/commons/kymw00/pless-view-helper-sub";
import { KYMW7402Model } from "./kymw7402.model";
import { CheckboxLabelComponent } from "src/app/commons/kymw02/checkbox-label/checkbox-label.component";
import { CellRange, CellType, FlexGrid } from '@grapecity/wijmo.grid';
import * as wjGrid from '@grapecity/wijmo.grid';
import { Menu } from '@grapecity/wijmo.input';
import { KYMW00Model } from "src/app/commons/kymw00/kymw00.model";
import { RadioLabelComponent } from "src/app/commons/kymw02/radio-label/radio-label.component";
import { GetCodeListService } from "src/app/commons/kymw02/api-services/get-code-list.service";
import { GetGoodsCoopByItemCodeService } from "./api-services/get-goods-coop-by-item-code.service";
import { GetFixedOrderListService } from "./api-services/get-fixed-order-list.service";
import { GetRememberGoodsInfoService } from "./api-services/get-remember-goods-info.service";
import { GetRememberOrderNumService } from "./api-services/get-remember-order-num.service";
import { UpdateRememberGoodsInfoService } from "./api-services/update-remember-goods-info.service";
import { UpdateRememberGoodsInfoForFixedService } from "./api-services/update-remember-goods-info-for-fixed.service";
import { CodeComboBoxComponent } from "src/app/commons/kymw02/combo-box/code-combo-box/code-combo-box.component";
import { TextInputComponent } from "src/app/commons/kymw02/text-input/text-input/text-input.component";
import { PlessViewUtilsSub } from "src/app/commons/kymw00/pless-view-utils-sub.service";
import { DetailInfoModel } from "./vo/detail-Info.model";
import { GoodsCoopStatus } from "./vo/goods-coop.model";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { GetOrderListService } from "src/app/commons/kymw02/api-services/get-order-list.service";
import { RememberGoodsInfoModel } from "./vo/remember-goods-info.model";
import { PlessAlert } from "src/app/shared/pless-alert/pless-alert.component";
import { ActivatedRoute, Router } from "@angular/router";
import { EventArgs } from "@grapecity/wijmo";
import { GetOldCatalogProgressCatalogInfo } from "./api-services/get-old-catalog-progress-catalog-info.service";

/**
 * 忘れず注文商品登録画面を管理するクラス
 *
 * @export KYMW7402Component
 * @class KYMW7402Component
 */
@Component({
  selector: 'app-kymw7402',
  templateUrl: 'kymw7402.component.html',
  styleUrls: ['kymw7402.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW7402Component extends PlessViewHelperSub implements OnInit, AfterViewInit {

  public kymw7402Model: KYMW7402Model = new KYMW7402Model();
  /** 価格情報　入力項目 */
  public detailInfo: DetailInfoModel = new DetailInfoModel();
  /** 利用生協モデル */
  public coopStatus: { [key: string]: GoodsCoopStatus } = {
    coop_ibaraki: new GoodsCoopStatus(this.kymw00Model.COOP_CODE_IB),
    coop_tochigi: new GoodsCoopStatus(this.kymw00Model.COOP_CODE_TO),
    coop_gunma: new GoodsCoopStatus(this.kymw00Model.COOP_CODE_GU),
    coop_chiba: new GoodsCoopStatus(this.kymw00Model.COOP_CODE_TI),
    coop_saitama: new GoodsCoopStatus(this.kymw00Model.COOP_CODE_SA),
    coop_tokyo: new GoodsCoopStatus(this.kymw00Model.COOP_CODE_TK),
    coop_nagano: new GoodsCoopStatus(this.kymw00Model.COOP_CODE_NA),
    coop_niigata: new GoodsCoopStatus(this.kymw00Model.COOP_CODE_NI),
  }
  public coopStatusList = Object.values(this.coopStatus);

  isComposing = false;

  // 基本情報
  @ViewChild('cmb_DeliveryCycleDiv', { static: true }) cmb_DeliveryCycleDiv: CodeComboBoxComponent;
  @ViewChild('cmb_GoodsCatalogDiv', { static: true }) cmb_GoodsCatalogDiv: CodeComboBoxComponent;
  @ViewChild('cmb_RememberCategoryCode', { static: true }) cmb_RememberCategoryCode: CodeComboBoxComponent;
  @ViewChild('cmb_MonthlyDeliveryTimes', { static: true }) cmb_MonthlyDeliveryTimes: ElementRef;

  /** カテゴリコード codeDiv格納用 */
  categoryCodeReserve1: string = '';

  // 利用生協
  @ViewChild('chk_AllCoop', { static: true }) chk_AllCoop: CheckboxLabelComponent;
  @ViewChild('chk_Seikyou1', { static: true }) chk_Seikyou1: CheckboxLabelComponent;
  @ViewChild('chk_Seikyou2', { static: true }) chk_Seikyou2: CheckboxLabelComponent;
  @ViewChild('chk_Seikyou3', { static: true }) chk_Seikyou3: CheckboxLabelComponent;
  @ViewChild('chk_Seikyou4', { static: true }) chk_Seikyou4: CheckboxLabelComponent;
  @ViewChild('chk_Seikyou5', { static: true }) chk_Seikyou5: CheckboxLabelComponent;
  @ViewChild('chk_Seikyou6', { static: true }) chk_Seikyou6: CheckboxLabelComponent;
  @ViewChild('chk_Seikyou7', { static: true }) chk_Seikyou7: CheckboxLabelComponent;
  @ViewChild('chk_Seikyou8', { static: true }) chk_Seikyou8: CheckboxLabelComponent;

  // 価格情報一覧
  @ViewChild('dtg_detailInfoList', { static: true }) dtg_detailInfoList: FlexGrid;
  /** 価格情報一覧　コンテキストメニュー */
  detailInfoListContextMenu: Menu;
  /** 価格情報一覧　コンテキストメニュー削除　活性制御用 */
  isEnabledContextMenu: boolean = <boolean>true;

  /** 企画確定企画回セット */
  fixedCatalogIdSet: Set<string> = new Set();

  /** 配達終了企画回確定フラグ (真の場合、全項目編集不可) */
  isFixedDeliveryEndCatalog: boolean = <boolean>false;

  /** 配達終了企画回 企画進捗管理最古企画フラグ (真の場合、全項目編集不可) */
  isBeforeOldestDeliveryEndCatalog: boolean = <boolean>false;

  /** 基本情報項目の活性制御 */
  basicInfoALLDisabled: boolean = <boolean>false;

  /** 価格情報項目の活性制御 */
  detailInfoALLDisabled: boolean = <boolean>false;

  /**
   * 活性制御状態を保持
   * 個別で活性制御が必要な項目はここで制御
   */
  disabledStatus = {
    basicInfo: {
      /** 受注受付終了企画回の活性制御 */
      orderReceptionEndCatalog: <boolean>false,

      /** 配達終了企画回の活性制御 */
      deliveryEndCatalog: <boolean>false,
    },

    detailInfo: {
      /** 適用開始企画回の活性制御 */
      applicableStartCatalog: <boolean>false,

      /** 適用終了企画回の活性制御 */
      applicableEndCatalog: <boolean>false,

      /** 配達休止の活性制御 */
      pauseDelivery: <boolean>false,

      /** 値引区分セレクトボックスの活性制御 */
      cmbDiscountType: <boolean>false,

      /** 値引単価の活性制御 */
      discountUnitPrice: <boolean>false,

      /** 値引率の活性制御 */
      discountRate: <boolean>false,

      /** 専用商品名の活性制御 */
      rememberGoodsName: <boolean>false,

      /** 専用商品名(ｶﾅ)の活性制御 */
      rememberGoodsNameKana: <boolean>false,

      /** 専用規格名の活性制御 */
      rememberStandardName: <boolean>false,

      /** 専用規格名(ｶﾅ)の活性制御 */
      rememberStandardNameKana: <boolean>false,

      /** 行追加の活性制御 */
      addRow: <boolean>false,

      /** 行更新の活性制御 */
      updateRow: <boolean>true,
    }
  }
  /** 承認ボタンの活性制御 */
  public btnApproveDisabled: boolean = <boolean>false;

  /** 登録ボタンの活性制御 */
  public btnRegistDisabled: boolean = <boolean>false;

  /** 注文コード自動付番の活性制御 */
  public btnRememberOrderNumDisabled: boolean = <boolean>false;

  /** ボタンの表示制御
   * 
   *  Regist: 登録ボタン表示
   *  Approve: 承認ボタン表示
   */
  btnDisplay: string = <string>'';

  /** 更新時に使用するindex */
  updateRowIndex: number = <number>0;

  /** ユーザ権限 */
  public isFullControl = this.getFuncPermission('KYMW7400') === this.kymw00Model.FUNC_PERMISSION_FULLCONTROL;

  /**
   * Creates an instance of KYMW0001Component.
   * 
   * @param dialogService 
   * @param kymw00Model 
   * @param getCodeListService 
   * @param getGoodsCoopByItemCodeService 
   * @param getFixedOrderListService 
   * @param getRememberGoodsInfoService 
   * @param getRememberOrderNumService 
   * @param updateRememberGoodsInfoService 
   * @param updateRememberGoodsInfoForFixedService 
   * @param getOrderListService
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private getCodeListService: GetCodeListService,
    private getGoodsCoopByItemCodeService: GetGoodsCoopByItemCodeService,
    private getFixedOrderListService: GetFixedOrderListService,
    private getRememberGoodsInfoService: GetRememberGoodsInfoService,
    private getRememberOrderNumService: GetRememberOrderNumService,
    private getOrderListService: GetOrderListService,
    private updateRememberGoodsInfoService: UpdateRememberGoodsInfoService,
    private updateRememberGoodsInfoForFixedService: UpdateRememberGoodsInfoForFixedService,
    private getOldCatalogProgressCatalogInfoService: GetOldCatalogProgressCatalogInfo,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private elementRef: ElementRef,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   * 
   */
  ngOnInit(): void {
    this.componentName = 'kymw7402';
    this.kymw7402Model.kymw7402Componet = this;

    this.activatedRoute.queryParams.subscribe((params) => {
      // 遷移元からのパラメータ取得
      if ('itemCode' in params) {
        this.kymw7402Model.itemCode = params['itemCode'];
      }
      if ('rememberGoodsId' in params) {
        this.kymw7402Model.rememberGoodsId = params['rememberGoodsId'];
      }
      // 検索フラグ
      this.kymw7402Model.searchFlg = params['searchFlg'];
      // 検索条件
      this.kymw7402Model.searchOrderReceptionCatalog = params['searchOrderReceptionCatalog'];
      this.kymw7402Model.searchClassCode = params['searchClassCode'];
      this.kymw7402Model.searchPCode = params['searchPCode'];
      this.kymw7402Model.searchDeliveryCatalog = params['searchDeliveryCatalog'];
      this.kymw7402Model.searchBuyerCode = params['searchBuyerCode'];
      this.kymw7402Model.searchGuideGoodsName = params['searchGuideGoodsName'];
      this.kymw7402Model.searchOrderNum = params['searchOrderNum'];
      this.kymw7402Model.searchItemCode = params['searchItemCode'];
      this.kymw7402Model.searchGuideStandardName = params['searchGuideStandardName'];
    })

    // 承認ユーザ
    this.getCodeListService.execute('ctp323', '', this.kymw7402Model, 'authoritySetIdList',
      () => {
        //セッション情報のユーザの権限セットID
        const authoritySetID = this.kymw00Model.kymw1001Model.loginUserInfo.AuthoritySetID;
        for (let i = 0; i < this.kymw7402Model.authoritySetIdList.length; i++) {
          //取得したCodeValueのうち、セッション情報のユーザの権限セットIDと一致するものがある場合
          if (parseInt(authoritySetID) === parseInt(this.kymw7402Model.authoritySetIdList[i].CodeValue)) {
            this.kymw7402Model.authorizedUserFlag = true;
            break;
          }
        }
      }
    )

    // 利用生協情報取得
    this.getGoodsCoopByItemCodeService.execute(this.kymw7402Model, (serverData: any) => {
      this.setGoodsCoopCheckBoxEnabled(serverData);
    });

    // 企画確定受注コード一覧取得
    this.getFixedOrderListService.execute(this.kymw7402Model, (data: any) => {
      this.fixedCatalogIdSet = new Set(this.kymw7402Model.fixedOrderList.map(_ => _.CatalogId));
    });

    // バリデーションチェック時に用いる企画回情報取得
    this.getOrderListService.execute(this.kymw7402Model, 'orderList');

    this.getOldCatalogProgressCatalogInfoService.execute((data) => {
      this.kymw7402Model.oldCatalogProgressCatalogInfo.orderCode = data.OrderCode;
      this.kymw7402Model.oldCatalogProgressCatalogInfo.catalogId = data.CatalogId;
    });

    // グリッドの初期選択行はなしとする
    this.dtg_detailInfoList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_detailInfoList.select(-1, -1);
    });

    // フルコントロールの場合、注文コード自動付番を活性
    this.btnRememberOrderNumDisabled = !this.isFullControl;
  }

  /**
   * ビュー初期化
   * 
   */
  ngAfterViewInit() {
    // 忘れず注文商品情報取得
    this.getRememberGoodsInfoService.execute(this.kymw7402Model, () => {
      this.setDisabled();
      this.setButtonDisplay();
      this.createContextMenu();
      this.eventDiscountType_CHANGEHandler();

      // ctp338のカテゴリコードリストを一度全て取得
      this.getCodeListService.execute('ctp338', '', this.kymw7402Model, 'categoryCodeList', () => {
        //　配達サイクル区分の値に紐づくカテゴリコードをコンボボックスの中身に設定
        this.eventDeliveryCycleDiv_CHANGEHandler();
      });
    });
  }

  /**
   * 入力項目の活性制御
   * 
   */
  public setDisabled() {
    // 新規追加の場合は全て活性のまま
    if (PlessViewUtilsSub.isEmpty(this.kymw7402Model.rememberGoodsId)) return;

    // 受注受付開始企画回が企画確定している場合、
    // または
    // 受注受付開始企画回 が 企画進捗管理最古の配達企画回(翌週)より小さい場合、
    // 基本情報を編集不可とする。
    const isFixedOrderReceptionStartCatalog =
      this.fixedCatalogIdSet.has(this.kymw7402Model.orderReceptionStartCatalog) ||
      this.kymw7402Model.orderReceptionStartCatalog < this.kymw7402Model.oldCatalogProgressCatalogInfo.catalogId;
    if (isFixedOrderReceptionStartCatalog) {
      this.basicInfoALLDisabled = true;
    }

    // 配達終了企画回が企画確定済
    this.isFixedDeliveryEndCatalog = this.fixedCatalogIdSet.has(this.kymw7402Model.deliveryEndCatalog);
    // 配達終了企画回が企画進捗管理最古より前
    this.isBeforeOldestDeliveryEndCatalog = this.kymw7402Model.deliveryEndCatalog < this.kymw7402Model.oldCatalogProgressCatalogInfo.catalogId;

    // 配達終了企画回が企画確定済の場合、
    // または
    // 配達終了企画回 が 企画進捗管理最古の配達企画回(翌週)より小さい場合、
    // 全項目を入力不可とする。また、行追加ボタンは非活性。
    if (this.isFixedDeliveryEndCatalog || this.isBeforeOldestDeliveryEndCatalog) {
      this.basicInfoALLDisabled = true;
      this.detailInfoALLDisabled = true;
      this.disabledStatus.detailInfo.addRow = true;
    }

    // 受注受付開始企画回が企画確定済かつ配達終了企画回が企画確定していない場合、
    // 「受注受付終了企画回」と「配達終了企画回」は編集可能とし、それ以外の基本情報項目は非活性とする
    if (isFixedOrderReceptionStartCatalog && (this.isFixedDeliveryEndCatalog || this.isBeforeOldestDeliveryEndCatalog)) {
      this.disabledStatus.basicInfo.orderReceptionEndCatalog = true;
      this.disabledStatus.basicInfo.deliveryEndCatalog = true;
    }
  }

  /**
   * ボタンの表示制御
   * 
   * 該当ボタン：「承認」 「登録」
   */
  public setButtonDisplay() {
    // 承認ユーザーの場合 登録ボタン：非表示　承認ボタン：表示・活性
    if (this.kymw7402Model.authorizedUserFlag) {
      this.btnDisplay = 'Approve';
      this.btnApproveDisabled = !this.isFullControl;

    } else {
      // 登録ボタン：表示・活性　承認ボタン：非表示
      this.btnDisplay = 'Regist';
      this.btnRegistDisabled = !this.isFullControl;
    }
  }

  /**
   * 価格情報一覧 
   * コンテキストメニューの設定
   * 
   */
  public createContextMenu() {
    this.detailInfoListContextMenu = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          {
            header: '削除', caption: '削除', cmd: 'delete', enabled: true
          },
        ],
        command: {
          canExecuteCommand: (param) => {
            // 各項目の活性制御
            return (param.enabled === false) ? false : true;
          }
        },
        // イベント設定
        itemClicked: () => {
          // 行削除処理
          this.eventDeleteRow_CLICKHandler();
        }
      });

    this.dtg_detailInfoList.hostElement.addEventListener('contextmenu', (e: any) => {
      e.preventDefault();
      if (this.detailInfoListContextMenu !== undefined) {
        this.eventContextMenu_SELECTHandler(e);
        this.detailInfoListContextMenu.show(e);
      }
    })
  }

  /**
   * コンテキストメニューを呼び出した際のイベント
   * 
   */
  public eventContextMenu_SELECTHandler(event: any) {
    const ht = this.dtg_detailInfoList.hitTest(event.pageX, event.pageY);
    // 右クリック押下時に対象行を選択状態にする
    if (ht.cellType === wjGrid.CellType.Cell) {
      const grid = new CellRange(ht.row, ht.col);
      this.dtg_detailInfoList.select(grid, false);
    }
    this.eventDetailInfoList_CLICKHandler(event, this.dtg_detailInfoList);
    this.detailInfoListContextMenu.itemsSource.forEach(item => {
      if (item.caption = "削除") {
        if (this.isFullControl) {
          //フルコントロールの場合
          // isEnabledContextMenu は価格情報行選択イベントで設定されている
          item.enabled = this.isEnabledContextMenu;
        } else {
          //フルコントロール以外の場合
          item.enabled = false;
        }
      }
    });
  }

  /**
   * 価格情報一覧
   * コンテキストメニュー　行削除イベント
   * 
   */
  public eventDeleteRow_CLICKHandler() {
    if (this.dtg_detailInfoList.selectedItems != null) {
      const rowIndex = this.dtg_detailInfoList.selection.row;
      this.dtg_detailInfoList.itemsSource.splice(rowIndex, 1);

      // 行選択を未選択とする
      const grid = new CellRange(-1, -1);
      this.dtg_detailInfoList.select(grid, false);
      this.dtg_detailInfoList.collectionView.refresh();

      // 価格情報を初期化
      this.kymw7402Model.applicableStartCatalog = '';
      this.kymw7402Model.applicableEndCatalog = '';
      this.kymw7402Model.pauseDelivery = false;
      this.kymw7402Model.discountType = '0';
      this.kymw7402Model.discountUnitPrice = '';
      this.kymw7402Model.discountRate = '';
      this.kymw7402Model.discountPrice = '';
      this.kymw7402Model.rememberGoodsName = '';
      this.kymw7402Model.rememberGoodsNameKana = '';
      this.kymw7402Model.rememberStandardName = '';
      this.kymw7402Model.rememberStandardNameKana = '';
      // 活性化
      this.setDisabled_DetailInfo(false);
      this.isEnabledContextMenu = false;
      this.eventDiscountType_CHANGEHandler();
    }
  }

  /**
   * 価格情報行選択
   * 
   * @param e 
   * @param grid 価格情報一覧
   */
  public eventDetailInfoList_CLICKHandler(e: MouseEvent, grid: FlexGrid) {
    e.preventDefault();

    const ht = grid.hitTest(e.pageX, e.pageY);

    if (!PlessViewUtilsSub.isEmptyArray(grid.itemsSource)) {
      // ヘッダー内部がクリックされた場合
      if (ht.cellType === wjGrid.CellType.Cell &&
        !PlessViewUtilsSub.isEmptyArray(grid.selectedItems)) {
        this.updateRowIndex = grid.selection.row;
        // 選択行の情報を入力項目に表示
        this.kymw7402Model.applicableStartCatalog = grid.selectedItems[0].applicableStartCatalog;
        this.kymw7402Model.applicableEndCatalog = grid.selectedItems[0].applicableEndCatalog;
        // 配達停止区分の設定
        if (grid.selectedItems[0].pauseDelivery === '1') {
          this.kymw7402Model.pauseDelivery = true;
        } else if (grid.selectedItems[0].pauseDelivery === '0') {
          this.kymw7402Model.pauseDelivery = false;
        }
        this.kymw7402Model.discountType = grid.selectedItems[0].discountType;
        this.kymw7402Model.discountUnitPrice = grid.selectedItems[0].discountUnitPrice;
        this.kymw7402Model.discountRate = grid.selectedItems[0].discountRate;
        this.kymw7402Model.rememberGoodsName = grid.selectedItems[0].rememberGoodsName;
        this.kymw7402Model.rememberGoodsNameKana = grid.selectedItems[0].rememberGoodsNameKana;
        this.kymw7402Model.rememberStandardName = grid.selectedItems[0].rememberStandardName;
        this.kymw7402Model.rememberStandardNameKana = grid.selectedItems[0].rememberStandardNameKana;

        // 入力項目の活性制御
        if (!this.isFixedDeliveryEndCatalog && !this.isBeforeOldestDeliveryEndCatalog) {
          // 配達終了企画回が企画確定でない場合、かつ、企画進捗管理最古企画より後の場合、各項目を活性化

          // 活性制御初期化
          this.detailInfoALLDisabled = false;
          this.isEnabledContextMenu = true;
          this.disabledStatus.detailInfo.applicableEndCatalog = false;
          this.disabledStatus.detailInfo.updateRow = false;

          let isStartFix = false;
          let isEndFix = false;

          // 適用開始企画回が企画確定
          if (this.fixedCatalogIdSet.has(this.kymw7402Model.applicableStartCatalog)) {
            isStartFix = true;
          }

          // 適用終了企画回が企画確定
          if (this.fixedCatalogIdSet.has(this.kymw7402Model.applicableEndCatalog)) {
            isEndFix = true;
          }

          // 適用開始企画回 が 企画進捗管理最古企画回 よりも前の場合
          let isBeforeOldestApplicableStartCatalog = this.kymw7402Model.applicableStartCatalog < this.kymw7402Model.oldCatalogProgressCatalogInfo.catalogId;
          // 適用終了企画回 が 企画進捗管理最古企画回 よりも前の場合
          let isBeforeOldestApplicableEndCatalog = this.kymw7402Model.applicableEndCatalog < this.kymw7402Model.oldCatalogProgressCatalogInfo.catalogId;

          if (isEndFix || isBeforeOldestApplicableEndCatalog) {
            // 適用終了企画回が、企画確定しているまたは企画進捗管理最古企画回よりも前 の場合はすべて編集不可
            this.detailInfoALLDisabled = true;
            this.disabledStatus.detailInfo.updateRow = true;
            this.isEnabledContextMenu = false;
          } else if (isStartFix || isBeforeOldestApplicableStartCatalog) {
            // 適用開始企画回のみが、企画確定しているまたは企画進捗管理最古企画回よりも前 の場合は適用終了企画回のみ編集可能
            this.detailInfoALLDisabled = false;
            this.setDisabled_DetailInfo(true); // 一度全てtrueにしてから適用終了企画回と更新ボタンのみfalseにする
            this.disabledStatus.detailInfo.applicableEndCatalog = false;
            this.disabledStatus.detailInfo.updateRow = false;
            this.isEnabledContextMenu = false;
          } else {
            // どちらも企画確定していない場合、価格情報すべて編集可能
            this.detailInfoALLDisabled = false;
            this.setDisabled_DetailInfo(false);
            this.eventDiscountType_CHANGEHandler();
            this.isEnabledContextMenu = true;
          }
        }

        // 追加ボタンを非活性
        this.disabledStatus.detailInfo.addRow = true;

        // 値引後供給単価の設定
        // 単価指定の場合
        if (this.kymw7402Model.discountType === "1") {
          this.eventDiscountUnitPrice_CHANGEHandler();
        } else if (this.kymw7402Model.discountType === "2") {
          // 率指定の場合
          this.eventDiscountRate_CHANGEHandler();
        } else if (this.kymw7402Model.discountType === "0") {
          // 値引きなしの場合
          this.kymw7402Model.discountPrice = this.kymw7402Model.masterPrice;
        }
      }
    }
  }

  /**
   * 利用生協チェックボックスの活性制御
   * 
   * @param serverData 
   */
  public setGoodsCoopCheckBoxEnabled(serverData: any) {
    if (Array.isArray(serverData.CoopCodeList)) {
      // APIレスポンス 生協コードに存在する生協チェックボックスを活性に設定する。
      const coopCodeList: string[] = serverData.CoopCodeList;
      let allDisabled = true;
      for (const coopStatus of this.coopStatusList) {
        const disabled = coopStatus.setDisabled(coopCodeList);
        allDisabled = allDisabled && disabled;
      }
      this.chk_AllCoop.disabled = allDisabled;
    }
  }

  /**
   * 利用生協情報取得
   * 
   */
  public setGoodsCoopCheckBoxChecked(data: any) {
    if (Array.isArray(data)) {
      const coopCodeList = data;
      // APIレスポンス 生協コードに存在する生協チェックボックスにチェックを付ける。
      for (let i = Number(0); i < coopCodeList.length; i++) {
        for (let j = 0; j < this.coopStatusList.length; j++) {
          this.coopStatusList[j].setChecked(coopCodeList)
        }
      }
      // ALLのチェック設定
      this.eventSeikyou_CLICKHandler();
    }
  }

  /**
   * 「ALL」チェックボタン押下イベント処理
   *
   *  @event イベント
   */
  public eventAllCoop_CLICKHandler() {
    const allCheck = this.kymw7402Model.chk_all;

    this.coopStatusList.forEach(coop => {
      if (!coop.disabled) {
        coop.checked = allCheck;
      }
    })
  }

  /**
   * 生協のチェックを変更したときのイベント処理
   * 
   */
  public eventSeikyou_CLICKHandler() {
    // チェックされた生協のチェックボックスを格納
    const coopCheckedTarget = this.coopStatusList.filter(
      coop => coop.checked
    );
    // 活性状態の生協を格納
    const coopEnabledTarget = this.coopStatusList.filter(
      coop => !coop.disabled
    )

    // チェックされた生協の数が活性状態の生協数と一致しているか（一致：「ALL」をチェック、不一致：「ALL」からチェックを外す）
    if (coopCheckedTarget.length === coopEnabledTarget.length) {
      this.kymw7402Model.chk_all = true;
    } else {
      this.kymw7402Model.chk_all = false;
    }
  }

  /**
   * 注文コード自動付番 ボタン押下
   * 
   */
  public eventSetRememberOrderNum_CLICKHandler() {
    this.getRememberOrderNumService.execute(this.kymw7402Model);
  }

  /**
   * 受注受付終了企画回 変更イベント
   * 
   */
  public eventOrderReceptionStartCatalog_CHANGEHandler() {
    // 受注受付終了企画回に値がない場合、受注受付開始企画回に入力された値を受注受付終了企画回に設定する。
    if (this.kymw7402Model.orderReceptionEndCatalog === "") {
      this.kymw7402Model.orderReceptionEndCatalog = this.kymw7402Model.orderReceptionStartCatalog;
    }
  }

  /**
   * 配達サイクル区分 変更イベント
   * 
   * 「月毎配達回」の活性制御を行う
   * 　値に紐づく「カテゴリコード」コンボボックスの中身を設定
   */
  public eventDeliveryCycleDiv_CHANGEHandler() {
    // 41：１ヶ月毎、42：２ヶ月毎、43：３ヶ月毎、44：４ヶ月毎、45：５ヶ月毎、46：６ヶ月毎
    const value = ['41', '42', '43', '44', '45', '46'];

    // 入力された値が41~46のいずれか区分値であり
    // 月毎配達回が非活性である場合、月毎配達回を活性に設定する
    if (value.includes(this.kymw7402Model.deliveryCycleDiv) &&
      this.cmb_MonthlyDeliveryTimes.nativeElement.disabled && !this.basicInfoALLDisabled) {
      this.cmb_MonthlyDeliveryTimes.nativeElement.disabled = false;

    } else if (!value.includes(this.kymw7402Model.deliveryCycleDiv) &&
      !this.cmb_MonthlyDeliveryTimes.nativeElement.disabled) {
      // 41~46以外であり、
      // かつ、月毎配達回が活性である場合、月毎配達回を""(空文字)、非活性に設定する。
      this.kymw7402Model.monthlyDeliveryTimes = "";
      this.cmb_MonthlyDeliveryTimes.nativeElement.disabled = true;
    }

    let categoryCodeList = this.kymw7402Model.categoryCodeList;
    // 配達サイクル区分の値に紐づくカテゴリコードで絞り込む
    categoryCodeList = categoryCodeList.filter(code => code.Reserve1 == this.kymw7402Model.deliveryCycleDiv);
    this.cmb_RememberCategoryCode.model.updateCodeList(categoryCodeList);

  }

  /**
   * 配達サイクル区分 変更イベント
   * 
   * 初期処理回避
   */
  public updateCategoryCodeDiv() {
    // カテゴリコードが選択されている場合、その選択をクリアする。
    if (!PlessViewUtilsSub.isEmpty(this.kymw7402Model.rememberCategoryCode)) {
      this.kymw7402Model.rememberCategoryCode = "";
    }
  }

  /**
   * 適用開始企画回 変更イベント
   * 
   */
  public eventApplicableStartCatalog_CHANGEHandler() {
    // 適用終了企画回に値がない場合、適用開始企画回に入力された値を適用終了企画回に設定する。
    if (this.kymw7402Model.applicableEndCatalog === "") {
      this.kymw7402Model.applicableEndCatalog = this.kymw7402Model.applicableStartCatalog;
    }
  }

  /**
   * 値引き区分ラジオボタン 変更イベント
   * 
   */
  public eventDiscountType_CHANGEHandler() {
    // 選択された値が「1:単価指定」である場合、値引率を""(空文字)、非活性に設定する
    // 値引単価を活性に設定する
    if (this.kymw7402Model.discountType === '1') {
      this.kymw7402Model.discountRate = '';
      this.disabledStatus.detailInfo.discountRate = true;
      this.disabledStatus.detailInfo.discountUnitPrice = false;

    } else if (this.kymw7402Model.discountType === '2') {
      // 選択された値が「2:率指定」である場合、値引単価を""(空文字)、非活性に設定する。
      // 値引率を活性に設定する。
      this.kymw7402Model.discountUnitPrice = '';
      this.disabledStatus.detailInfo.discountRate = false;
      this.disabledStatus.detailInfo.discountUnitPrice = true;

    } else if (this.kymw7402Model.discountType === '0') {
      // 選択された値が「0:値引きなし」である場合、値引単価、値引率を""(空文字)、非活性に設定する。
      this.kymw7402Model.discountRate = '';
      this.kymw7402Model.discountUnitPrice = '';
      this.disabledStatus.detailInfo.discountRate = true;
      this.disabledStatus.detailInfo.discountUnitPrice = true;
    }
    // 値引後供給単価をクリアする
    this.kymw7402Model.discountPrice = '';
  }

  /**
   * 値引き単価 入力イベント
   * 
   */
  public eventDiscountUnitPrice_CHANGEHandler() {
    this.kymw7402Model.discountPrice = this.getDiscountPriceForUnit(this.kymw7402Model.discountUnitPrice);
  }

  /**
   * 値引き率 入力イベント
   * 
   */
  public eventDiscountRate_CHANGEHandler() {
    this.kymw7402Model.discountPrice = this.getDiscountPriceForRate(this.kymw7402Model.discountRate);
  }

  private getDiscountPriceForUnit(discountUnitPrice: any) {
    if (discountUnitPrice === '') {
      discountUnitPrice = 0;
    }

    const discountPrice = Number(this.kymw7402Model.masterPrice) - Number(discountUnitPrice);
    return discountPrice.toString();
  }

  private getDiscountPriceForRate(discountRate: any) {
    if (this.kymw7402Model.discountRate === '') {
      discountRate = 0;
    }

    const masterPrice = Number(this.kymw7402Model.masterPrice);
    const discountPrice = masterPrice - (masterPrice / 100 * Number(discountRate));
    return Math.floor(discountPrice).toString();
  }

  /**
   * 価格情報入力項目 バリデーション
   * 
   * @param addInfo 入力情報
   * @param rowIndex 行更新時に使用 
   * @param footerBtn 登録ボタン, 承認ボタン押下時true
   * @returns 
   */
  public inputCheckDetail(addInfo, rowIndex: any = null, footerBtn: boolean = false): boolean {
    // 大小比較など用にstringをnumberに変更(空は0ではなくnull)
    const discountUnitPrice = PlessViewUtilsSub.stringToNumber(addInfo.discountUnitPrice);
    const masterPrice = PlessViewUtilsSub.stringToNumber(this.kymw7402Model.masterPrice);
    const discountRate = PlessViewUtilsSub.stringToNumber(addInfo.discountRate);
    const applicableStartCatalog = PlessViewUtilsSub.stringToNumber(addInfo.applicableStartCatalog);
    const orderReceptionStartCatalog = PlessViewUtilsSub.stringToNumber(this.kymw7402Model.orderReceptionStartCatalog);
    const applicableEndCatalog = PlessViewUtilsSub.stringToNumber(addInfo.applicableEndCatalog);
    const deliveryEndCatalog = PlessViewUtilsSub.stringToNumber(this.kymw7402Model.deliveryEndCatalog);

    // 必須チェック
    if (PlessViewUtilsSub.isEmpty(addInfo.applicableStartCatalog)) {
      this.dialogService.openAlertGetMessage('W0001', ['適用開始企画回']);
      return false;
    }
    // 必須チェック
    if (PlessViewUtilsSub.isEmpty(addInfo.applicableEndCatalog)) {
      this.dialogService.openAlertGetMessage('W0001', ['適用終了企画回']);
      return false;
    }

    // 値引区分が値引単価の場合
    if (addInfo.discountType === '1') {
      // 必須チェック
      if (PlessViewUtilsSub.isEmpty(addInfo.discountUnitPrice)) {
        this.dialogService.openAlertGetMessage('W0001', ['値引単価']);
        return false;
      }
      if (!footerBtn) {
        // 値引単価不整合チェック
        if (discountUnitPrice > masterPrice) {
          this.dialogService.openAlertGetMessage('W0024', ['値引単価']);
          return false;
        }
      }

    } else if (addInfo.discountType === '2') {
      // 値引区分が値引率の場合
      // 必須チェック
      if (PlessViewUtilsSub.isEmpty(addInfo.discountRate)) {
        this.dialogService.openAlertGetMessage('W0001', ['値引率']);
        return false;
      }
      if (!footerBtn) {
        // 値引率不整合チェック
        if (discountRate < 0 || 100 < discountRate) {
          this.dialogService.openAlertGetMessage('W0024', ['値引率']);
          return false;
        }
      }
    }

    // 必須チェック
    if (PlessViewUtilsSub.isEmpty(addInfo.rememberGoodsName)) {
      this.dialogService.openAlertGetMessage('W0001', ['専用商品名']);
      return false;
    }
    // 必須チェック
    if (PlessViewUtilsSub.isEmpty(addInfo.rememberGoodsNameKana)) {
      this.dialogService.openAlertGetMessage('W0001', ['専用商品名(ｶﾅ)']);
      return false;
    }
    // 必須チェック
    if (PlessViewUtilsSub.isEmpty(addInfo.rememberStandardName)) {
      this.dialogService.openAlertGetMessage('W0001', ['専用規格名']);
      return false;
    }
    // 必須チェック
    if (PlessViewUtilsSub.isEmpty(addInfo.rememberStandardNameKana)) {
      this.dialogService.openAlertGetMessage('W0001', ['専用規格名(ｶﾅ)']);
      return false;
    }

    // 行追加、行更新の場合
    if (!footerBtn) {
      // 行追加の場合
      if (rowIndex === null) {
        // 適用開始企画回が企画確定の場合
        // または、企画進捗管理最古企画より前の場合
        if (this.fixedCatalogIdSet.has(addInfo.applicableStartCatalog) ||
          addInfo.applicableStartCatalog < this.kymw7402Model.oldCatalogProgressCatalogInfo.catalogId
        ) {
          this.dialogService.openAlertGetMessage('E0233', ['適用開始企画回', '企画確定していない企画回']);
          return false;
        }
      } else {
        // 行更新の場合
        // 適用終了企画回が企画確定済の場合
        // または、企画進捗管理最古企画より前の場合
        if (this.fixedCatalogIdSet.has(addInfo.applicableEndCatalog) ||
          addInfo.applicableEndCatalog < this.kymw7402Model.oldCatalogProgressCatalogInfo.catalogId
        ) {
          this.dialogService.openAlertGetMessage('E0537', []);
          return false;
        }
      }

      // 適用開始企画回＜受注受付開始企画回の場合
      if (applicableStartCatalog < orderReceptionStartCatalog) {
        this.dialogService.openAlertGetMessage('W0024', ['適用開始企画回']);
        return false;
      }

      // 適用終了企画回＞配達終了企画回の場合
      // または、適用開始企画回と適用終了企画回が逆転している場合
      if (applicableEndCatalog > deliveryEndCatalog || applicableStartCatalog > applicableEndCatalog
      ) {
        this.dialogService.openAlertGetMessage('W0024', ['適用終了企画回']);
        return false;
      }

      // すでに価格情報（表示リスト）に行が存在する場合
      const detailInfoList = this.kymw7402Model.detailInfoList;
      if (!PlessViewUtilsSub.isEmptyArray(detailInfoList)) {

        for (let i = 0; i < detailInfoList.length; i++) {
          // 更新の場合は、他の行と比較
          if (i !== rowIndex) {
            // 適用開始企画回・適用終了企画回が他行の内容と重複する場合
            if (addInfo.applicableStartCatalog === detailInfoList[i].applicableStartCatalog) {
              this.dialogService.openAlertGetMessage('W0024', ['適用開始企画回']);
              return false;
            }
            if (addInfo.applicableEndCatalog === detailInfoList[i].applicableEndCatalog) {
              this.dialogService.openAlertGetMessage('W0024', ['適用終了企画回']);
              return false;
            }
          }

          // 追加の場合、前の行の企画回を調べる
          if (rowIndex === null && i === detailInfoList.length - 1) {
            let nextCatalog;
            const orderList = this.kymw7402Model.orderList;
            for (let j = 0; j < orderList.length; j++) {
              // 前行の企画回の翌企画回を取得
              if (orderList[j].CatalogID === detailInfoList[i].applicableEndCatalog) {
                nextCatalog = orderList[j + 1].CatalogID;
                break;
              }
            }
            // 適用開始企画回が前行の適用終了企画回の翌企画回以外の場合
            if (addInfo.applicableStartCatalog !== nextCatalog) {
              this.dialogService.openAlertGetMessage('W0024', ['適用開始企画回']);
              return false;
            }
          }

          // 更新の場合、前後行の企画回と連続かチェック
          // 前の行
          if (rowIndex !== null && i === rowIndex - 1) {
            let nextCatalog;
            const orderList = this.kymw7402Model.orderList;
            for (let j = 0; j < orderList.length; j++) {
              // 前行の適用終了企画回の翌企画回を取得
              if (orderList[j].CatalogID === detailInfoList[i].applicableEndCatalog) {
                nextCatalog = orderList[j + 1].CatalogID;
                break;
              }
            }
            // 適用開始企画回が前行の適用終了企画回の翌企画回以外の場合
            if (addInfo.applicableStartCatalog !== nextCatalog) {
              this.dialogService.openAlertGetMessage('W0024', ['適用開始企画回']);
              return false;
            }

          } else if (rowIndex !== null && i === rowIndex + 1) {
            // 後ろの行
            let previousCatalog;
            const orderList = this.kymw7402Model.orderList;
            for (let j = 0; j < orderList.length; j++) {
              // 後ろの行の適用開始企画回の前企画回を取得
              if (orderList[j].CatalogID === detailInfoList[i].applicableStartCatalog) {
                previousCatalog = orderList[j - 1].CatalogID;
                break;
              }

            }
            // 適用終了企画回が前行の適用開始企画回の直前企画回以外の場合
            if (addInfo.applicableEndCatalog !== previousCatalog) {
              this.dialogService.openAlertGetMessage('W0024', ['適用開始企画回']);
              return false;
            }
          }
        }
      }
    }

    return true;
  }

  /**
   * 行追加・更新用
   * 価格情報VO作成
   * 
   */
  public createRowVO() {
    let addInfo = new DetailInfoModel();
    addInfo.applicableStartCatalog = this.kymw7402Model.applicableStartCatalog;
    addInfo.applicableEndCatalog = this.kymw7402Model.applicableEndCatalog;
    if (this.kymw7402Model.pauseDelivery) {
      addInfo.pauseDelivery = "1";
    } else {
      addInfo.pauseDelivery = "0";
    }
    addInfo.discountType = this.kymw7402Model.discountType;
    addInfo.discountUnitPrice = this.kymw7402Model.discountUnitPrice;
    addInfo.discountRate = this.kymw7402Model.discountRate;
    addInfo.discountPrice = this.kymw7402Model.discountPrice;
    addInfo.rememberGoodsName = this.kymw7402Model.rememberGoodsName;
    addInfo.rememberGoodsNameKana = this.kymw7402Model.rememberGoodsNameKana;
    addInfo.rememberStandardName = this.kymw7402Model.rememberStandardName;
    addInfo.rememberStandardNameKana = this.kymw7402Model.rememberStandardNameKana;

    return addInfo;
  }

  /** クリアボタン押下時 */
  public eventClearInput_CLICKHandler() {
    // 入力内容をクリア
    this.kymw7402Model.applicableStartCatalog = '';
    this.kymw7402Model.applicableEndCatalog = '';
    this.kymw7402Model.pauseDelivery = false;
    this.kymw7402Model.discountType = '0';
    this.kymw7402Model.discountUnitPrice = '';
    this.kymw7402Model.discountRate = '';
    this.kymw7402Model.discountPrice = '';
    this.kymw7402Model.rememberGoodsName = '';
    this.kymw7402Model.rememberGoodsNameKana = '';
    this.kymw7402Model.rememberStandardName = '';
    this.kymw7402Model.rememberStandardNameKana = '';
    // 活性・非活性を初期化
    this.detailInfoALLDisabled = false;
    this.setDisabled_DetailInfo(false);
    this.disabledStatus.detailInfo.updateRow = true;
    this.eventDiscountType_CHANGEHandler();
    this.isEnabledContextMenu = false;

    // 行選択を解除
    if (this.dtg_detailInfoList) {
      this.dtg_detailInfoList.select(-1, -1); // 空の CellRange を指定
    }
  }

  /**
   * 行追加ボタン押下時
   * 
   */
  public eventAddRow_CLICKHandler() {
    const addInfo = this.createRowVO();

    // 価格情報入力チェック
    if (this.inputCheckDetail(addInfo)) {
      this.kymw7402Model.detailInfoList.push(addInfo);
      this.dtg_detailInfoList.collectionView.refresh();
    }
  }

  /**
   * 行更新ボタン押下時
   * 
   */
  public eventUpdateRow_CLICKHandler() {
    let addInfo = this.createRowVO();

    // 価格情報入力チェック
    if (this.inputCheckDetail(addInfo, this.updateRowIndex)) {
      this.kymw7402Model.detailInfoList.splice(this.updateRowIndex, 1, addInfo);
      this.dtg_detailInfoList.collectionView.refresh();
    }
  }

  /**
   * 基本情報入力項目　バリデーション
   * 
   * @param value 
   */
  public inputCheckBase(info: any) {
    // 必須チェック
    if (PlessViewUtilsSub.isEmpty(info.orderNum)) {
      this.dialogService.openAlertGetMessage('W0001', ['注文コード']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(info.orderChangeOrderNum)) {
      this.dialogService.openAlertGetMessage('W0001', ['注文数変更用注文コード']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(info.orderReceptionStartCatalog)) {
      this.dialogService.openAlertGetMessage('W0001', ['受注受付開始企画回']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(info.orderReceptionEndCatalog)) {
      this.dialogService.openAlertGetMessage('W0001', ['受注受付終了企画回']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(info.deliveryStartCatalog)) {
      this.dialogService.openAlertGetMessage('W0001', ['配達開始企画回']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(info.deliveryEndCatalog)) {
      this.dialogService.openAlertGetMessage('W0001', ['配達終了企画回']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(info.deliveryCycleDiv)) {
      this.dialogService.openAlertGetMessage('W0001', ['配達サイクル区分']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(info.goodsCatalogDiv)) {
      this.dialogService.openAlertGetMessage('W0001', ['商品企画担当区分']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(info.pauseGroupCode)) {
      this.dialogService.openAlertGetMessage('W0001', ['休止グループコード']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(info.coopCodes)) {
      this.dialogService.openAlertGetMessage('W0001', ['利用生協']);
      return false;
    }
    let result: boolean = false;
    for (let i = 0; i < info.detailInfoList.length; i++) {
      result = this.inputCheckDetail(info.detailInfoList[i], null, true);
      if (!result) {
        return false;
      }
    }
    return true;
  }

  /**
   * 登録・承認用のVO作成
   * 
   * @param data 
   */
  public createVO(): RememberGoodsInfoModel {
    const info = new RememberGoodsInfoModel();
    info.rememberGoodsId = this.kymw7402Model.rememberGoodsId;
    info.rememberGoodsStatus = this.kymw7402Model.rememberGoodsStatus;
    info.itemCode = this.kymw7402Model.itemCode;
    info.orderNum = this.kymw7402Model.orderNum;
    info.orderChangeOrderNum = this.kymw7402Model.orderChangeOrderNum;
    if (this.kymw7402Model.increaseGoods) {
      info.increaseGoods = '1';
    } else {
      info.increaseGoods = '0';
    }
    info.rememberCategoryCode = this.kymw7402Model.rememberCategoryCode;
    info.orderReceptionStartCatalog = this.kymw7402Model.orderReceptionStartCatalog;
    info.orderReceptionEndCatalog = this.kymw7402Model.orderReceptionEndCatalog;
    info.deliveryStartCatalog = this.kymw7402Model.deliveryStartCatalog;
    info.deliveryEndCatalog = this.kymw7402Model.deliveryEndCatalog;
    info.deliveryCycleDiv = this.kymw7402Model.deliveryCycleDiv;
    info.monthlyDeliveryTimes = this.kymw7402Model.monthlyDeliveryTimes;
    info.goodsCatalogDiv = this.kymw7402Model.goodsCatalogDiv;
    info.pauseGroupCode = this.kymw7402Model.pauseGroupCode;

    // 利用生協をAPIリクエストパラメーターの形にする
    // チェックされたもののcoopCodeをカンマ区切りにする
    const coopCodes = this.coopStatusList.filter(coop => coop.checked).map(coop => coop.coopCode);
    info.coopCodes = coopCodes.join(',');

    info.detailInfoList = this.kymw7402Model.detailInfoList;
    for (const e of info.detailInfoList) {
      if (e.discountType === '1') {
        e.discountPrice = this.getDiscountPriceForUnit(e.discountUnitPrice);
      } else if (e.discountType === '2') {
        e.discountPrice = this.getDiscountPriceForRate(e.discountRate);
      } else if (e.discountType === '0') {
        e.discountPrice = this.kymw7402Model.masterPrice;
      }
    }

    return info;
  }

  /**
   * 登録ボタン押下時
   * 
   */
  public eventRegist_CLICKHandler() {
    // 登録時は忘れず注文商品ステータスは空欄
    this.kymw7402Model.rememberGoodsStatus = '';
    const inputVO = this.createVO();

    if (this.inputCheckBase(inputVO)) {
      this.dialogService.openAlertGetMessage(
        'Q0104', ['忘れず注文商品情報'],
        (closeDetail) => {
          if (closeDetail === PlessAlert.Yes) {
            this.updateRememberGoodsInfoService.execute(this.kymw7402Model, inputVO, () => {
              this.dialogService.openAlertGetMessage('I0508', ['登録処理'], close => {
                if (close === PlessAlert.Yes) {
                  this.router.navigate(['/kymw/7400'], {
                    queryParams: {
                      // 検索フラグ
                      searchFlg: this.kymw7402Model.searchFlg,
                      // 検索条件
                      searchOrderReceptionCatalog: this.kymw7402Model.searchOrderReceptionCatalog,
                      searchClassCode: this.kymw7402Model.searchClassCode,
                      searchPCode: this.kymw7402Model.searchPCode,
                      searchDeliveryCatalog: this.kymw7402Model.searchDeliveryCatalog,
                      searchBuyerCode: this.kymw7402Model.searchBuyerCode,
                      searchGuideGoodsName: this.kymw7402Model.searchGuideGoodsName,
                      searchOrderNum: this.kymw7402Model.searchOrderNum,
                      searchItemCode: this.kymw7402Model.searchItemCode,
                      searchGuideStandardName: this.kymw7402Model.searchGuideStandardName
                    },
                  });
                }
              });
            });
          }
        }
      );
    }
  }

  /**
   * 承認ボタン押下時
   * 
   */
  public eventApprove_CLICKHandler() {
    if (PlessViewUtilsSub.isEmpty(this.kymw7402Model.orderReceptionEndCatalog)) {
      this.dialogService.openAlertGetMessage('W0001', ['受注受付終了企画回']);
      return
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw7402Model.deliveryEndCatalog)) {
      this.dialogService.openAlertGetMessage('W0001', ['配達終了企画回']);
      return
    }

    /** 受注受付開始企画回が企画確定状態 */
    let isFixed: boolean = false;
    // 受注受付開始企画回が企画確定している場合
    // または
    // 受注受付開始企画回が企画進捗管理最古企画より小さい場合
    if (this.fixedCatalogIdSet.has(this.kymw7402Model.orderReceptionStartCatalog) ||
      this.kymw7402Model.orderReceptionStartCatalog < this.kymw7402Model.oldCatalogProgressCatalogInfo.catalogId
    ) {
      isFixed = true;
    }

    // 承認時は忘れず注文商品ステータスは'2"
    this.kymw7402Model.rememberGoodsStatus = '2';
    const inputVO = this.createVO();

    // 企画確定している場合
    if (isFixed) {
      for (let i = 0; i < inputVO.detailInfoList.length; i++) {
        if (!this.inputCheckDetail(inputVO.detailInfoList[i], null, true)) break;
      }

      this.dialogService.openAlertGetMessage(
        'Q0108', ['忘れず注文商品情報'],
        (closeDetail: any) => {
          if (closeDetail === PlessAlert.Yes) {
            this.updateRememberGoodsInfoForFixedService.execute(this.kymw7402Model, inputVO, () => {
              this.updateSuccessFunc();
            });
          }
        }
      );
    } else {
      // 企画確定していない場合
      if (this.inputCheckBase(inputVO)) {
        // カテゴリコードは承認時のみ必須
        if (PlessViewUtilsSub.isEmpty(inputVO.rememberCategoryCode)) {
          this.dialogService.openAlertGetMessage('W0001', ['カテゴリコード']);
          return;
        }

        this.dialogService.openAlertGetMessage(
          'Q0108', ['忘れず注文商品情報'],
          (closeDetail: any) => {
            if (closeDetail === PlessAlert.Yes) {
              this.updateRememberGoodsInfoService.execute(this.kymw7402Model, inputVO, () => {
                this.updateSuccessFunc();
              });
            }
          }
        );
      }
    }
  }

  /**
   * 承認API成功後処理
   * 
   */
  public updateSuccessFunc() {
    this.dialogService.openAlertGetMessage('I0508', ['承認処理'], close => {
      if (close === PlessAlert.Yes) {
        this.router.navigate(['/kymw/7400'], {
          queryParams: {
            // 検索フラグ
            searchFlg: this.kymw7402Model.searchFlg,
            // 検索条件
            searchOrderReceptionCatalog: this.kymw7402Model.searchOrderReceptionCatalog,
            searchClassCode: this.kymw7402Model.searchClassCode,
            searchPCode: this.kymw7402Model.searchPCode,
            searchDeliveryCatalog: this.kymw7402Model.searchDeliveryCatalog,
            searchBuyerCode: this.kymw7402Model.searchBuyerCode,
            searchGuideGoodsName: this.kymw7402Model.searchGuideGoodsName,
            searchOrderNum: this.kymw7402Model.searchOrderNum,
            searchItemCode: this.kymw7402Model.searchItemCode,
            searchGuideStandardName: this.kymw7402Model.searchGuideStandardName
          },
        });
      }
    })
  }

  /**
   * 戻るボタン押下
   * 
   */
  public eventBack_CLICKHandler() {
    // kymw7400 忘れず注文商品一覧に戻る
    this.router.navigate(['/kymw/7400'], {
      queryParams: {
        // 検索フラグ
        searchFlg: this.kymw7402Model.searchFlg,
        // 検索条件
        searchOrderReceptionCatalog: this.kymw7402Model.searchOrderReceptionCatalog,
        searchClassCode: this.kymw7402Model.searchClassCode,
        searchPCode: this.kymw7402Model.searchPCode,
        searchDeliveryCatalog: this.kymw7402Model.searchDeliveryCatalog,
        searchBuyerCode: this.kymw7402Model.searchBuyerCode,
        searchGuideGoodsName: this.kymw7402Model.searchGuideGoodsName,
        searchOrderNum: this.kymw7402Model.searchOrderNum,
        searchItemCode: this.kymw7402Model.searchItemCode,
        searchGuideStandardName: this.kymw7402Model.searchGuideStandardName
      },
    });
  }

  /**
   * 専用商品名(ｶﾅ)の入力から半角カンマを削除
   */
  public eventRememberGoodsNameKana_deleteCommaHandler(): void {
    this.kymw7402Model.rememberGoodsNameKana = this.kymw7402Model.rememberGoodsNameKana.replace(/,/g, '');
  }

  /**
   * 専用規格名(ｶﾅ)の入力から半角カンマを削除
   */
  public eventRememberStandardNameKana_deleteCommaHandler(): void {
    this.kymw7402Model.rememberStandardNameKana = this.kymw7402Model.rememberStandardNameKana.replace(/,/g, '');
  }

  onCompStart() {
    this.isComposing = true;
  }
  // 全角入力から半角カンマに変換した時に削除するためのメソッド
  onCompDeleteCommaEnd(e: Event) {
    this.isComposing = false;
    (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.replace(/,/g, '');
  }

  /**
   * 価格情報を全て非活性にする
   * @param disabled 
   */
  private setDisabled_DetailInfo(disabled: boolean) {
    Object.keys(this.disabledStatus.detailInfo).forEach(key => {
      this.disabledStatus.detailInfo[key as keyof typeof this.disabledStatus.detailInfo] = disabled;
    })
  }
}

